<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h6 style="color: #101010;line-height: 31px;" class="mb-0">
        {{ $l('form_header_userOptions') || '未授权用户' }}
      </h6>
      <div class="flex-grow-1 pl-4">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="searchKey"
              :placeholder="
                $l('authUser_search_placeholder') || '用户账号/用户名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </div>
    </div>
    <PageMain
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :roleID="roleID"
      @reload="reload"
    />
    <pagination
      slot="pager"
      class="mt-1"
      align="left"
      :current-page="page.curPage"
      :page-size="page.pageSize"
      :page-total="page.pageTotal"
      :layouts="['Total', 'Sizes', 'PrevPage', 'NextPage', 'FullJump']"
      @change="handlePaginationChange"
    />
  </div>
</template>

<script>
import PageMain from './main'
const initPage = { curPage: 1, pageSize: 20, pageTotal: 0 }
export default {
  components: { PageMain },
  props: { roleID: { type: String, default: '' } },
  data() {
    return {
      page: { ...initPage },
      searchKey: '',
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    query() {
      this.page = { ...initPage }
      this.getData()
    },
    async getData() {
      this.loading = true
      const res = await this.$api
        .merchantRoleUserOptionsApi({
          roleID: this.roleID,
          ...this.page,
          searchKey: this.searchKey,
        })
        .catch(() => null)
      this.loading = false
      if (!res) return
      this.tableData = res.body.data
      this.page.pageTotal = res.body.count
      this.page.pageSize = res.body.pageSize
      this.page.curPage = res.body.curPage
    },
    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData()
    },
    reload() {
      this.getData()
      this.$emit('reload')
    },
  },
}
</script>
